import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
// component, hooks
import AccordionMain from "../../../../../../../common/components/accordion/AccordionMain";
// import AccordionSummaryTail from "./AccordionSummaryTail";
import AccordionDetailChildren from "./AccordionDetailChildren";
// store
// config,utils

// style

const PrivateDataset = () => {
  // props

  // route,intl
  const intl = useIntl();
  // store
  // local state
  // hooks

  return (
    <Box>
      <AccordionMain
        accordionProps={{}}
        darkMode
        summaryChildren={{
          text: intl.formatMessage({
            id: "sna.sidebar.filetool.group.groupdataset",
            defaultMessage: "團隊",
          }),
          // tail: <AccordionSummaryTail />,
        }}
        detailsChildren={<AccordionDetailChildren />}
        detailsProps={{}}
      />
    </Box>
  );
};

PrivateDataset.propTypes = {};

PrivateDataset.defaultProps = {};

export default PrivateDataset;
